import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

export function NavigationButtons() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const handleBack = () => {
    if (typeof window !== "undefined") {
      window.history.back();
    }
  };

  return (
    <nav className="hidden fixed top-3 left-3 z-50 flex items-center gap-1 rounded-full border border-border bg-card/90 px-2 py-1.5 shadow-lg backdrop-blur-sm sm:top-4 sm:left-4 sm:gap-3 sm:px-4 sm:py-2">
      {!isHome && (
        <button
          onClick={handleBack}
          className="inline-flex items-center gap-2 rounded-full px-3 py-2 text-sm font-medium text-foreground transition-colors hover:bg-accent hover:text-accent-foreground sm:px-4"
          aria-label="Voltar para a página anterior"
        >
          <ArrowLeft className="h-4 w-4" />
          <span className="hidden sm:inline">Voltar</span>
        </button>
      )}
      <Link
        to="/"
        className="inline-flex items-center gap-2 rounded-full px-3 py-2 text-sm font-medium text-foreground transition-colors hover:bg-accent hover:text-accent-foreground sm:px-4"
        aria-label="Ir para a página inicial"
      >
        <Home className="h-4 w-4" />
        <span className="hidden sm:inline">Home</span>
      </Link>
    </nav>
  );
}
